<template lang="pug">
.status-badge(:class="classes")
  UiTooltip
    template(#activator)
      UiBadge(
        size="sm"
        :variant="variant"
      )
        slot {{ label || status }}
    slot(name="tooltip") 
      template(v-if="!isLargeTooltip") {{ `Status reason: \"${tooltip}\"` }}
      template(v-else)
        p.text-left(v-for="p in tooltip") {{ p }}
</template>

<script>
let statusBadgeUniqIndex = 0;

export default {
  props: {
    status: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: null,
    },
    defaultVariant: {
      type: String,
      default: "secondary",
    },
    statusVariants: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      index: statusBadgeUniqIndex++,
    };
  },

  computed: {
    isLargeTooltip() {
      return Array.isArray(this.tooltip);
    },
    classes() {
      return {
        "status-badge--interactive": this.tooltip,
      };
    },
    statusVariantsWithDefaults() {
      return {
        suggested: "primary",
        failed: "danger",
        not_suggested: "warning",
        ...this.statusVariants,
      };
    },
    variant() {
      return (
        this.statusVariantsWithDefaults[this.status] ?? this.defaultVariant
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.status-badge {
  display: inline-block;

  &--interactive {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.status-badge-tooltip {
  &-large .tooltip-inner {
    max-width: 520px !important;
  }
}
</style>
